import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import SeafoamButton from "../Buttons/SeafoamButton/SeafoamButton";
import "./SlideOutMenuSectioned.css";

function SlideOutMenuFilter({
  show,
  setShow,
  menuHeader,
  actionButtonText,
  onActionButtonClick,
  clearFields,
  onClearFieldsClick,
  onCancel,
  sectionsArray,
  showDivider = true,
}) {
  const handleClose = () => setShow(false);

  // Stops scroll of the body if the slide-out menu is open.
  // The overlay hangs off <body> rather than off a .navbar sibling: under
  // release.react-nav the page renders in layouts/project.html.haml, which has
  // no navbar at all, and querying for one returned null. Only the overflow
  // property is touched (not the whole style attribute) because that same
  // layout relies on inline `margin: 0; padding: 0; overflow: hidden` on body.
  useEffect(() => {
    if (!show) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const screenOverlay = document.createElement("div");
    screenOverlay.classList.add("screenOverlay");
    document.body.appendChild(screenOverlay);

    return () => {
      document.body.style.overflow = previousOverflow;
      screenOverlay.remove();
    };
  }, [show]);

  return (
    <div className={show ? "slideOutMenu show" : "slideOutMenu hide"}>
      <div className="slideOutHeader">
        <h3>{menuHeader}</h3>
        <div className="ctas">
          <Button
            onClick={() => {
              onCancel();
              handleClose();
            }}
            variant="secondary"
            className="cancelBtn"
            id="cancelBtn"
          >
            {actionButtonText ? "Cancel" : "Close"}
          </Button>
          {actionButtonText && (
            <SeafoamButton
              onClick={onActionButtonClick}
              className="actionBtn"
              text={actionButtonText}
            />
          )}
        </div>
      </div>
      {clearFields ? (
        <div onClick={onClearFieldsClick} className="clearFields">
          {clearFields}
        </div>
      ) : null}
      {sectionsArray.map((section, index) => {
        return (
          <div className={section.containerClass} key={index}>
            {showDivider && <hr className="divider" />}
            <div className={section.sectionClass}>
              {section.sectionTitle && section.sectionTitle.length > 0 && (
                <div className="slideOutSectionTitle">
                  {section.sectionTitle}
                </div>
              )}
              <div>{section.sectionContent}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default SlideOutMenuFilter;
